import React from "react";
// import SlidingComponent from "../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import Switch from "react-switch";

const RestaurantChainSelectToggle = ({ localProps, state, ...props }) => {
  return (
    <div className="restaurant_chains_onboarding_main">
      <div className="row">
        <div className="col-7 col-sm-7 col-md-10 col-lg-10 col-xl-10 restaurant_chains_onboarding_main_divone">
          <div className="f16-700">Are you part of a chain?</div>
          <div className="f12-400 opacity5">
            (Select a business establishment from the list below or click on
            'Set Up New' to set a new chain business)
          </div>
        </div>
        <div className="col-5 col-sm-5 col-md-2 col-lg-2 col-xl-2 restaurant_chains_onboarding_main_divtwo">
          <Switch
            name="partofchains"
            checked={state.are_you_part_of_chain}
            onChange={localProps.onToggleHandler(
              "are_you_part_of_chain",
              !state.are_you_part_of_chain
            )}
            offColor="#EEEEEE"
            onColor="#EEEEEE"
            offHandleColor="#212121"
            onHandleColor="#59F832"
            handleDiameter={22}
            uncheckedIcon={false}
            checkedIcon={false}
            height={14}
            width={38}
            boxShadow="-2px 0px 5px #0000003B"
            activeBoxShadow="-2px 0px 5px #0000003B"
            id="material-switch"
          />
          {/* <SlidingComponent
            name="partofchains"
            currentState={state.are_you_part_of_chain}
            type={"checkbox"}
            toggleclass={"toggle d-flex align-items-center mb-2"}
            toggleinputclass={"toggle__switch"}
            onChange={localProps.onToggleHandler(
              "are_you_part_of_chain",
              !state.are_you_part_of_chain
            )}
            checked={state.are_you_part_of_chain}
            // slidingonClick={this.onSelecttogglestatusChange(data)}
            // defaultChecked={state.are_you_part_of_chain === true ? true : false}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default RestaurantChainSelectToggle;
